<template>
  <div class="mall-order-container" :class="{ 'detail-mode': showDetails }">
    <div v-if="!showDetails">
      <el-card shadow="never" id="mallOrder" style="min-height: 700px">
        <div id="resetInput" class="topHandle">
          <div class="search-box">
            <el-input class="box-item" clearable placeholder="输入订单编号" v-model.trim="queryParams.orderNo" prefix-icon="el-icon-search" />
            <el-input class="box-item" clearable placeholder="输入商品名称" v-model.trim="queryParams.productName" prefix-icon="el-icon-search" />
            <el-select class="box-item" v-model="queryParams.payType" :clearable="true" placeholder="请选择支付方式">
              <el-option
                v-for="item in payTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-date-picker
              class="box-item date-item"
              v-model="dateList"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="changeDate">
            </el-date-picker>
            <div class="search-actions">
              <el-button @click="resetParams">重置</el-button>
              <el-button type="primary" @click="getSearch">搜索</el-button>
            </div>
          </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="tab in tabsList" :key="tab.value" :label="tabLabel(tab)" :name="tab.value">
            <div class="table_head">
              <div class="table_head_col" :style="{ width: item.width }" v-for="item in headList" :key="item.index">{{ item.name }}</div>
            </div>
            <div class="table_content" v-loading="loading">
              <el-empty v-if="tableData.length == 0" description="暂无商城订单"></el-empty>
              <div class="table_content_card" v-for="item in tableData" :key="item.orderId">
                <div class="table_card_head">
                  <span>下单时间：{{ item.createdAt || '-' }}</span>
                  <span>订单号：{{ item.orderNo || '-' }}</span>
                  <span>物流信息：{{ shipmentSummary(item) }}</span>
                </div>
                <div class="table_card_body" @click="toDetails(item)">
                  <div class="table_body_name">
                    <div class="product-icon">
                      <i class="el-icon-shopping-bag-2"></i>
                    </div>
                    <div class="product-name">{{ item.productName || '-' }}</div>
                  </div>
                  <div class="table_body_othername font14666">{{ getPayTypeText(item.payType) }}</div>
                  <div class="table_body_othername">￥{{ item.amount }}</div>
                  <div class="table_body_othername font14666">
                    <span class="status-badge" :class="`status-${item.statusAlias}`">{{ statusText[item.statusAlias] || '处理中' }}</span>
                  </div>
                  <div class="table_body_othername font14666">{{ item.invoiceStatusText || '--' }}</div>
                  <div class="table_body_btn">
                    <div class="clickName" v-if="item.canPay" @click.stop="goMallPay(item)">立即支付</div>
                    <div class="clickName" v-if="item.canCancel" @click.stop="handleCancel(item)">取消订单</div>
                    <div class="clickName" v-if="item.canConfirm" @click.stop="handleConfirmReceipt(item)">确认收货</div>
                    <div class="clickName" v-if="item.canApplyInvoice" @click.stop="goMallInvoice(item)">申请开票</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-footer">
              <el-pagination background v-if="total > 0" style="text-align: right;margin-top: 10px"
                layout="total,prev, pager, next,sizes,jumper" :current-page="queryParams.pageNum"
                :page-size="queryParams.pageSize" :total="total" @current-change="selPageChange"
                @size-change="handleSizeChange">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>

    <mall-order-details
      ref="mallOrderDetails"
      :client-id="getClientId()"
      order-type="personal"
      v-if="showDetails"
      @close="getList"
      @pay="goMallPay"
      @cancel="handleCancel"
      @confirm="handleConfirmReceipt"
      @invoice="goMallInvoice">
    </mall-order-details>
  </div>
</template>

<script>
import {
  cancelMallOrder,
  confirmMallOrder,
  mallOrderList,
  mallOrderStatusCount
} from "@/api/request";
import { getClient } from "@/plugins/auth";
import MallOrderDetails from "./mallOrderDetails.vue";

function readClientId() {
  try {
    const clientInfo = JSON.parse(getClient() || '{}')
    return clientInfo.clientId || ''
  } catch (error) {
    return ''
  }
}

function getMallBaseUrl() {
  const configUrl = (process.env.VUE_APP_REAGENT_MALL_URL || '').trim()
  if (configUrl) return configUrl.replace(/\/+$/, '')
  if (process.env.NODE_ENV === 'development') return 'http://localhost:8081'
  return window.location.origin
}

export default {
  components: { MallOrderDetails },
  data() {
    return {
      loading: false,
      activeName: '-1',
      showDetails: false,
      dateList: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderNo: '',
        productName: '',
        startDate: '',
        endDate: ''
      },
      tableData: [],
      statusCount: {
        all: 0,
        pending: 0,
        audit: 0,
        processing: 0,
        shipped: 0,
        delivered: 0,
        cancelled: 0,
        auditRejected: 0
      },
      payTypeList: [
        { value: '1', label: "个人预存" },
        { value: '2', label: "团队预存" },
        { value: '3', label: "支付宝" },
        { value: '4', label: "微信" },
        { value: '5', label: "个人信用" },
        { value: '6', label: "团队信用" },
      ],
      tabsList: [
        { label: '全部订单', value: '-1', countKey: 'all' },
        { label: '待支付', value: '0', countKey: 'pending' },
        { label: '待审核', value: '5', countKey: 'audit' },
        { label: '待发货', value: '1', countKey: 'processing' },
        { label: '待收货', value: '2', countKey: 'shipped' },
        { label: '已完成', value: '3', countKey: 'delivered' },
        { label: '已取消', value: '4', countKey: 'cancelled' },
        { label: '审核拒绝', value: '6', countKey: 'auditRejected' }
      ],
      statusText: {
        pending: '待支付',
        audit: '待审核',
        processing: '待发货',
        shipped: '待收货',
        delivered: '已完成',
        cancelled: '已取消',
        auditRejected: '审核拒绝'
      },
      headList: [
        { name: "商品名称", index: 1, width: "240px" },
        { name: "支付方式", index: 2, width: "90px" },
        { name: "应付款", index: 3, width: "150px" },
        { name: "订单状态", index: 4, width: "90px" },
        { name: "发票状态", index: 5, width: "90px" },
        { name: "操作", index: 6, width: "150px" }
      ]
    }
  },
  mounted() {
    this.fetchOrdersAndCount()
  },
  methods: {
    getClientId() {
      return readClientId()
    },
    tabLabel(tab) {
      if (tab.value === '-1') return tab.label
      return `${tab.label}(${this.statusCount[tab.countKey] || 0})`
    },
    getPayTypeText(payType) {
      const item = this.payTypeList.find(option => option.value === String(payType))
      return item ? item.label : '--'
    },
    normalizeOrder(item) {
      const statusAliasMap = {
        '0': 'pending',
        '1': 'processing',
        '2': 'shipped',
        '3': 'delivered',
        '4': 'cancelled',
        '5': 'audit',
        '6': 'auditRejected'
      }
      const invoiceStatusTextMap = {
        '1': '未开票',
        '2': '已开票',
        '3': '无需开票'
      }
      const getActionFlag = (key, fallback) => {
        if (Object.prototype.hasOwnProperty.call(item, key)) {
          return item[key] === true || item[key] === 'true'
        }
        return fallback
      }
      const statusAlias = item.statusAlias || statusAliasMap[String(item.orderStatus)] || 'processing'
      const amount = item.amount && typeof item.amount === 'object'
        ? item.amount.totalAmount
        : (item.amount != null ? item.amount : item.totalAmount)
      return {
        ...item,
        orderId: item.orderId,
        orderNo: item.orderNo || item.id || '',
        productName: item.firstGoodsName || item.productName || '',
        createdAt: item.addDate || item.createdAt || '',
        amount: Number(amount || 0).toFixed(2),
        statusAlias,
        invoiceStatusText: item.invoiceStatusText || invoiceStatusTextMap[String(item.invoiceStatus)] || '--',
        canPay: getActionFlag('canPay', statusAlias === 'pending'),
        canCancel: getActionFlag('canCancel', statusAlias === 'pending' || statusAlias === 'processing'),
        canConfirm: getActionFlag('canConfirm', statusAlias === 'shipped'),
        canApplyInvoice: getActionFlag('canApplyInvoice', statusAlias === 'delivered' && String(item.invoiceStatus) === '1'),
        carrierName: item.carrierName || '',
        trackingNo: item.trackingNo || ''
      }
    },
    shipmentSummary(order) {
      if (!order || (!order.carrierName && !order.trackingNo)) return '--'
      return [order.carrierName, order.trackingNo].filter(Boolean).join(' / ')
    },
    buildQueryParams() {
      return {
        ...this.queryParams,
        clientId: this.getClientId(),
        orderStatus: this.activeName
      }
    },
    async getList() {
      this.showDetails = false
      this.loading = true
      try {
        const payload = await mallOrderList(this.buildQueryParams())
        const rows = Array.isArray(payload && payload.rows)
          ? payload.rows
          : (payload && payload.data && Array.isArray(payload.data.rows) ? payload.data.rows : [])
        this.tableData = rows.map(this.normalizeOrder)
        this.total = Number((payload && payload.total) || (payload && payload.data && payload.data.total)) || this.tableData.length
      } catch (error) {
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.message) || '商城订单加载失败')
      } finally {
        this.loading = false
      }
    },
    async fetchStatusCount() {
      const clientId = this.getClientId()
      if (!clientId) return
      const res = await mallOrderStatusCount({ clientId })
      const data = res && res.data
      if (!data) return
      this.statusCount = {
        all: Number(data.all) || 0,
        pending: Number(data.pending) || 0,
        audit: Number(data.audit) || 0,
        processing: Number(data.processing) || 0,
        shipped: Number(data.shipped) || 0,
        delivered: Number(data.delivered) || 0,
        cancelled: Number(data.cancelled) || 0,
        auditRejected: Number(data.auditRejected) || 0
      }
    },
    async fetchOrdersAndCount() {
      try {
        await Promise.all([this.getList(), this.fetchStatusCount()])
      } catch (error) {
        this.$message.error((error && error.message) || '商城订单数据加载失败')
      }
    },
    init() {
      this.activeName = '-1'
      this.dateList = []
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        orderNo: '',
        productName: '',
        startDate: '',
        endDate: ''
      }
      this.fetchOrdersAndCount()
    },
    resetParams() {
      this.dateList = []
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        orderNo: '',
        productName: '',
        startDate: '',
        endDate: ''
      }
      this.activeName = '-1'
      this.fetchOrdersAndCount()
    },
    handleClick() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    changeDate(e) {
      this.queryParams.startDate = e ? e[0] : ''
      this.queryParams.endDate = e ? e[1] : ''
    },
    getSearch() {
      this.queryParams.pageNum = 1
      this.fetchOrdersAndCount()
    },
    selPageChange(page) {
      this.queryParams.pageNum = page
      this.getList()
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.queryParams.pageNum = 1
      this.getList()
    },
    toDetails(item) {
      this.showDetails = true
      this.$nextTick(() => {
        this.$refs.mallOrderDetails.getOrderInfo(item.orderId)
      })
    },
    async handleCancel(order) {
      if (!order || !order.orderId) return
      try {
        await this.$confirm('确认取消该商城订单吗？取消后不可恢复。', '取消订单', {
          confirmButtonText: '确认取消',
          cancelButtonText: '再想想',
          type: 'warning',
          closeOnClickModal: false
        })
      } catch (error) {
        return
      }
      try {
        await cancelMallOrder({
          clientId: this.getClientId(),
          orderId: order.orderId,
          cancelReason: '用户主动取消'
        })
        this.$message.success('订单已取消')
        await this.refreshAfterAction(order)
      } catch (error) {
        this.$message.error((error && error.message) || '取消订单失败')
      }
    },
    async handleConfirmReceipt(order) {
      if (!order || !order.orderId) return
      try {
        await this.$confirm(
          '<p class="receipt-check-tip">您货物已送达，请您现场核对：商品名称、规格型号、数量，检查外包装是否完好，有无破损漏液。</p><p class="receipt-warning-tip">确认无误后，点击确认收货；如有缺货、错发、破损等异常，请当场拍照留存并及时联系我们，感谢配合！</p>',
          '确认收货',
          {
            confirmButtonText: '确认收货',
            cancelButtonText: '我再核对一下',
            dangerouslyUseHTMLString: true,
            customClass: 'receipt-confirm-message-box',
            closeOnClickModal: false
          }
        )
      } catch (error) {
        return
      }
      try {
        await confirmMallOrder({
          clientId: this.getClientId(),
          orderId: order.orderId
        })
        this.$message.success('已确认收货')
        await this.refreshAfterAction(order)
      } catch (error) {
        this.$message.error((error && error.message) || '确认收货失败')
      }
    },
    async refreshAfterAction(order) {
      if (this.showDetails && this.$refs.mallOrderDetails) {
        await this.$refs.mallOrderDetails.getOrderInfo(order.orderId)
      } else {
        await this.fetchOrdersAndCount()
      }
    },
    buildMallUrl(path, query = {}) {
      const url = new URL(path, `${getMallBaseUrl()}/`)
      Object.keys(query).forEach(key => {
        if (query[key] !== undefined && query[key] !== null && query[key] !== '') {
          url.searchParams.set(key, query[key])
        }
      })
      return url.toString()
    },
    goMallPay(order) {
      if (!order || !order.orderId) return
      window.open(this.buildMallUrl('https://mall.navi-sci.cn/cart', { orderId: String(order.orderId) }), '_blank')
      // window.open(this.buildMallUrl('https://test.mall.navi-sci.cn/cart', { orderId: String(order.orderId) }), '_blank')
    },
    goMallInvoice(order) {
      if (!order || !order.orderId) return
      // 从商城订单直达订单操作-耗材开票，并带入当前订单打开开票组件。
      this.$router.push({
        path: '/aboutUsIndex',
        query: {
          type: 13,
          tabIndex: '2-4',
          tabName: '订单操作',
          operateIndex: 4,
          mallInvoiceOrderId: order.orderId,
        }
      }).catch(() => {})
    }
  }
}
</script>

<style>
#mallOrder .el-card__body {
  padding: 10px 35px;
}

#mallOrder .el-tabs__content {
  overflow: inherit;
}

/* 确认收货弹框由 body 承载，需要使用全局样式保持与设计稿一致。 */
.receipt-confirm-message-box {
  width: 480px;
  padding-bottom: 22px;
  border: 1px solid #d8dee9;
  border-radius: 2px;
}

.receipt-confirm-message-box .el-message-box__header {
  padding: 20px 22px 10px;
}

.receipt-confirm-message-box .el-message-box__title {
  justify-content: center;
  color: #172033;
  font-size: 18px;
  font-weight: 600;
}

.receipt-confirm-message-box .el-message-box__headerbtn {
  top: 17px;
  right: 17px;
  font-size: 18px;
}

.receipt-confirm-message-box .el-message-box__content {
  padding: 6px 22px 12px;
  color: #303133;
  font-size: 14px;
  line-height: 21px;
}

.receipt-confirm-message-box .receipt-check-tip,
.receipt-confirm-message-box .receipt-warning-tip {
  margin: 0;
}

.receipt-confirm-message-box .receipt-warning-tip {
  margin-top: 7px;
  color: #f04444;
}

.receipt-confirm-message-box .el-message-box__btns {
  display: flex;
  justify-content: center;
  padding: 0;
}

.receipt-confirm-message-box .el-button {
  min-width: 110px;
  height: 34px;
  padding: 0 18px;
  border-radius: 0;
  font-size: 14px;
}

.receipt-confirm-message-box .el-button--default:not(.el-button--primary) {
  color: #303133;
  border-color: #d8dee9;
}

.receipt-confirm-message-box .el-button--primary,
.receipt-confirm-message-box .el-button--primary:hover,
.receipt-confirm-message-box .el-button--primary:focus,
.receipt-confirm-message-box .el-button--primary:active {
  color: #27543b;
  background: #94f7c0;
  border-color: #94f7c0;
}

@media (max-width: 520px) {
  .receipt-confirm-message-box {
    width: calc(100% - 28px);
  }
}
</style>

<style scoped lang="scss">
.mall-order-container {
  width: 100%;
  height: calc(100vh - 200px);
}

.mall-order-container.detail-mode {
  height: auto;
  min-height: calc(100vh - 200px);
  overflow: visible;
}

.topHandle {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  .search-box {
    display: flex;
    gap: 10px;
    width: 100%;
    .box-item {
      display: flex;
      width: calc((100% - 30px) / 5);
    }
    .date-item {
      width: calc((100% - 30px) / 5);
    }
  }
}

.search-actions {
  display: flex;
  gap: 10px;
  white-space: nowrap;
}

.table_head {
  display: flex;
  flex-flow: row nowrap;
  background: #f5f5f5;
  text-align: center;
  justify-content: space-around;
  border-radius: 7px;
  margin: 20px 0;
  color: #111111;
  font-size: 14px;
  padding: 20px;
}

.table_content {
  overflow: auto;
  width: 100%;
  height: calc(100vh - 450px);
}

.table_content_card {
  cursor: pointer;
  margin-bottom: 20px;
  border-radius: 7px;
  border: 1px solid #e0e2ff;
}

.table_card_head {
  font-size: 14px;
  color: #666;
  background: #eaeffa;
  height: 36px;
  line-height: 36px;
  padding-left: 20px;
  border-bottom: 1px solid #e0e2ff;
  span {
    margin-right: 50px;
  }
}

.table_card_body {
  position: relative;
  padding: 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  font-size: 14px;
  color: #111;
}

.table_body_name {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 240px;
  text-align: left;
}

.product-icon {
  flex: 0 0 80px;
  width: 80px;
  height: 56px;
  border-radius: 12px;
  margin-right: 10px;
  background: #f6f8ff;
  color: #4d6fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
}

.product-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.table_body_othername {
  width: 90px;
  word-break: break-all;
}

.table_body_othername:nth-child(3) {
  width: 150px;
}

.table_body_btn {
  width: 150px;
  display: flex;
  flex-flow: column;
  row-gap: 4px;
}

.table-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.total-money {
  display: flex;
  align-items: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
}

.status-pending { background: #fff3e7; color: #c2410c; }
.status-audit { background: #fff8db; color: #a16207; }
.status-processing { background: #eaf1ff; color: #315fdc; }
.status-shipped { background: #f0eaff; color: #6d28d9; }
.status-delivered { background: #e7f8eb; color: #168239; }
.status-cancelled { background: #eef0f3; color: #666; }
.status-auditRejected { background: #fff0f0; color: #dc2626; }
</style>
